(function() {
	'use strict';

	class LoaderPresetsEnum {
		constructor(){			
			if (this.constructor !== LoaderKeysEnum) {
				throw new Error('Subclassing is not allowed.')
			}
		}

		static get SECTION_GLOBAL() {
			return 'section.global';
		}

		static get SECTION_TOP() {
			return 'section.top';
		}
		
		static get SECTION_LEFT() {
			return 'section.left';
		}

		static get SECTION_BOTTOM() {
			return 'section.bottom';
		}

		static get SECTION_RIGHT() {
			return 'section.right';
		}
		
		static get DIALOG_GLOBAL() {
			return 'dialog.global';
		}
		
		static getAll(){
			return new Set([
							this.SECTION_GLOBAL, 
							this.SECTION_TOP, 
							this.SECTION_LEFT, 
							this.SECTION_BOTTOM, 
							this.SECTION_RIGHT,
							this.DIALOG_GLOBAL
						   ]);
		}
	}

	window.LoaderPresetsEnum = LoaderPresetsEnum;
}());